import { render, staticRenderFns } from "./OsInputSlider.vue?vue&type=template&id=33173428&scoped=true"
import script from "./OsInputSlider.vue?vue&type=script&lang=ts"
export * from "./OsInputSlider.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33173428",
  null
  
)

export default component.exports